<template>
  <main class="main page-inside">
    <div class="profile">
      <div class="section profile-section">
        <div class="wrapper">
          <div class="title title-main">
            <img src="../img/Polygon2.svg" class="shop-arrow-left" />
            <img src="../img/Polygonhead.svg" class="shop-arrow-left" />
            PROFILE
            <img src="../img/Polygonhead.svg" class="shop-arrow-right" />
            <img src="../img/Polygon2.svg" class="shop-arrow-right" />
          </div>
          <div class="history-nav-section">
            <div class="nav">
              <div
                :class="['button', { active: activeTab == 1 }]"
                @click="activeTab = 1"
              >
                TRANSACTION HISTORY
              </div>
              <div
                :class="['button', { active: activeTab == 0 }]"
                @click="activeTab = 0"
              >
                ORDER HISTORY
              </div>
              <div
                :class="['button', { active: activeTab == 2 }]"
                @click="activeTab = 2"
              >
                SELL REQUESTS
              </div>
            </div>
          </div>
          <div class="profile-content">
            <div class="profile-info">
              <div class="profile-info-wrapper">
                <div class="profile-section-top">
                  <div class="profile-section-left">
                    <div class="icon-circle">
                      <img src="../img/user.svg" class="icon-img" />
                    </div>
                    <div class="profile-text-info">
                      <div class="profile-value">
                        {{ $parent.profileData.name }}
                      </div>
                      <div class="profile-value profile-id">
                        ID: {{ $parent.profileData.steam_id }}
                      </div>
                    </div>
                  </div>
                  <a class="logout-link" @click="$parent.logout">Log Out</a>
                </div>
                <div class="profile-section-bottom">
                  <div class="profile-section-left">
                    <div class="icon-circle">
                      <img src="../img/koshelek.svg" class="icon-img" />
                    </div>
                    <div class="profile-text-info">
                      <div class="profile-label">SPENDING BALANCE</div>
                      <div class="balance-amount">
                        <span class="balance-value">{{
                          Math.floor(($parent.profileData.balance || 0) * 100) /
                          100
                        }}</span>
                        <img src="../img/coin.svg" class="coin-icon" />
                      </div>
                    </div>
                  </div>
                  <button class="top-up-button" @click="$parent.openTopUpModal">
                    TOP UP
                  </button>
                </div>
                <template v-if="$parent.settings.payout_enabled">
                  <div class="profile-section-divider"></div>
                  <div class="profile-section-bottom">
                    <div class="profile-section-left">
                      <div class="icon-circle">
                        <img src="../img/payout-icon.svg" class="icon-img" />
                      </div>
                      <div class="profile-text-info">
                        <div class="profile-label">PAYOUT BALANCE</div>
                        <div class="balance-amount">
                          <span class="balance-value">{{
                            Math.floor(
                              ($parent.profileData.payout_balance || 0) * 100,
                            ) / 100
                          }}</span>
                          <img src="../img/coin.svg" class="coin-icon" />
                        </div>
                      </div>
                    </div>
                    <button
                      class="top-up-button"
                      @click="$parent.openWithdrawModal"
                    >
                      WITHDRAW
                    </button>
                  </div>
                </template>
              </div>
            </div>
            <div class="history-section">
              <div class="history-info">
                <div
                  class="table-container"
                  v-if="activeTab == 0 && $parent.orderHistory.length"
                >
                  <table>
                    <thead>
                      <tr>
                        <td>Date</td>
                        <td>Items</td>
                        <td>Total price</td>
                        <td>Status</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, i) in $parent.orderHistory" :key="i">
                        <td>{{ $parent.formatDate(item.date) }}</td>
                        <td>
                          <div
                            class="history-product"
                            v-for="(product, i) in item.items"
                            :key="i"
                          >
                            <img :src="imgDomain + product.image" class="img" />
                            <div class="name">
                              {{ product.display_name }}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="flex">
                            <b class="price">{{ item.total_price }}</b>
                            <img src="../img/coin.svg" class="coin" />
                          </div>
                        </td>
                        <td :class="'status ' + item.status">
                          <span>{{ item.status }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  class="table-container"
                  v-if="
                    activeTab == 1 &&
                    $parent.depositHistory &&
                    $parent.depositHistory.length
                  "
                >
                  <table>
                    <thead>
                      <tr>
                        <td>ID</td>
                        <td>DATE</td>
                        <td>TYPE</td>
                        <td>TOTAL</td>
                        <td>AMOUNT</td>
                        <td>STATUS</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, i) in $parent.depositHistory" :key="i">
                        <td>#{{ item.id || i + 1 }}</td>
                        <td>{{ $parent.formatDate(item.date) }}</td>
                        <td>Top Up Balance</td>
                        <td>
                          {{ item.amount }}
                          {{ $parent.currency }}
                        </td>
                        <td>
                          <div class="flex">
                            <b class="price">{{ item.amount }}</b>
                            <img src="../img/coin.svg" class="coin" />
                          </div>
                        </td>
                        <td :class="'status ' + item.status.toLowerCase()">
                          <span>{{ item.status }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="table-container" v-if="activeTab == 2">
                  <button
                    type="button"
                    class="sell-items-btn"
                    @click="handleSellItemsClick"
                  >
                    SELL ITEMS
                  </button>
                  <table>
                    <thead>
                      <tr>
                        <td>ID</td>
                        <td>DATE</td>
                        <td>ITEMS</td>
                        <td>TOTAL</td>
                        <td>STATUS</td>
                        <td>ACTION</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-if="
                          !$parent.sellRequestHistory ||
                          !$parent.sellRequestHistory.length
                        "
                      >
                        <td colspan="6" class="no-sell-requests">
                          No sell requests yet.
                        </td>
                      </tr>
                      <tr
                        v-for="(req, i) in $parent.sellRequestHistory"
                        :key="i"
                      >
                        <td>#{{ req.id }}</td>
                        <td>{{ $parent.formatDate(req.created_at) }}</td>
                        <td>
                          <div
                            class="sell-request-item"
                            v-for="(item, j) in req.items"
                            :key="j"
                          >
                            {{ item.short_name }} x{{ item.quantity }}
                          </div>
                        </td>
                        <td>
                          <div class="flex">
                            <b class="price">{{ req.total_amount }}</b>
                            <img src="../img/coin.svg" class="coin" />
                          </div>
                          <div
                            class="counter-offer-amount"
                            v-if="
                              req.counter_offer_amount !== null &&
                              req.status === 'CounterOffer'
                            "
                          >
                            <span class="counter-offer-label">Offer:</span>
                            <b class="price">{{ req.counter_offer_amount }}</b>
                            <img src="../img/coin.svg" class="coin" />
                          </div>
                        </td>
                        <td :class="'status ' + req.status.toLowerCase()">
                          <span>{{ formatStatus(req.status) }}</span>
                        </td>
                        <td class="action-cell">
                          <button
                            v-if="req.status === 'CounterOffer'"
                            class="action-btn view-offer-btn"
                            @click="$parent.openCounterOfferModal(req)"
                          >
                            VIEW OFFER
                          </button>
                          <span v-else class="no-action">—</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div
                    class="pagination"
                    v-if="$parent.sellRequestMeta.last_page > 1"
                  >
                    <button
                      class="pagination-btn"
                      :disabled="$parent.sellRequestMeta.current_page <= 1"
                      @click="
                        $parent.getSellRequestHistory(
                          $parent.sellRequestMeta.current_page - 1,
                        )
                      "
                    >
                      &laquo;
                    </button>
                    <button
                      class="pagination-btn"
                      v-for="p in $parent.sellRequestMeta.last_page"
                      :key="p"
                      :class="{
                        active: p === $parent.sellRequestMeta.current_page,
                      }"
                      @click="$parent.getSellRequestHistory(p)"
                    >
                      {{ p }}
                    </button>
                    <button
                      class="pagination-btn"
                      :disabled="
                        $parent.sellRequestMeta.current_page >=
                        $parent.sellRequestMeta.last_page
                      "
                      @click="
                        $parent.getSellRequestHistory(
                          $parent.sellRequestMeta.current_page + 1,
                        )
                      "
                    >
                      &raquo;
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer class="new-footer">
      <div class="footer-top">
        <div class="wrapper">
          <div class="footer-links">
            <a
              v-for="page in footerPages"
              :key="page.id"
              @click="$parent.goToPage(page)"
              class="footer-link"
            >
              {{ page.title.toUpperCase() }}
            </a>
          </div>
        </div>
      </div>
      <div class="footer-middle">
        <div class="wrapper">
          <div class="footer-column footer-column-left">
            <div class="footer-info">
              <div class="footer-info" v-if="$parent.settings">
                <div
                  class="footer-info-item"
                  v-if="$parent.settings.company_name"
                >
                  <span class="footer-info-label">COMPANY NAME:</span>
                  {{ $parent.settings.company_name }}
                </div>
                <div
                  class="footer-info-item"
                  v-if="$parent.settings.company_reg_number"
                >
                  <span class="footer-info-label">REGISTRATION NUMBER:</span>
                  {{ $parent.settings.company_reg_number }}
                </div>
                <div
                  class="footer-info-item"
                  v-if="$parent.settings.company_address"
                >
                  <span class="footer-info-label">ADDRESS:</span>
                  {{ $parent.settings.company_address }}
                </div>
              </div>
            </div>
          </div>
          <div class="footer-column footer-column-center">
            <router-link to="/" class="footer-logo">
              <img src="../img/footer logo.svg" class="footer-logo-img" />
            </router-link>
          </div>
          <div class="footer-column footer-column-right">
            <div class="footer-support">
              <div
                class="footer-support-email"
                v-if="$parent.settings && $parent.settings.support_email"
              >
                SUPPORT: {{ $parent.settings.support_email }}
              </div>
              <div class="footer-social-icons">
                <a
                  v-for="link in $parent.socials"
                  :key="link.image"
                  :href="link.link"
                  target="_blank"
                  class="footer-social-icon"
                >
                  <img :src="getSocialIcon(link.link)" :alt="link.link" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="wrapper">
          <div
            class="footer-copyright"
            v-if="$parent.settings && $parent.settings.copyright"
          >
            {{ $parent.settings.copyright }}
          </div>
          <div class="footer-payment-methods">
            <img
              src="../img/Mastercard.svg"
              class="payment-icon"
              alt="Mastercard"
            />
            <img src="../img/visa-pay.svg" class="payment-icon" alt="Visa" />
            <img
              src="../img/apple-pay.svg"
              class="payment-icon"
              alt="Apple Pay"
            />
            <img
              src="../img/google-pay.svg"
              class="payment-icon"
              alt="Google Pay"
            />
          </div>
        </div>
      </div>
    </footer>
  </main>
</template>
<script>
import acebookIcon from '../img/acebook.svg'
import instagramIcon from '../img/instagram.svg'
import steamIcon from '../img/steam.svg'

export default {
  name: 'Profile',
  props: [],
  components: {},
  data: function () {
    return {
      acebookIcon: acebookIcon,
      instagramIcon: instagramIcon,
      steamIcon: steamIcon,
      activeTab: 0,
      imgDomain: '',
    }
  },
  computed: {
    footerPages() {
      if (
        !this.$parent.textPageList ||
        !Array.isArray(this.$parent.textPageList)
      ) {
        return []
      }
      const keywords = ['terms', 'privacy', 'cookie']
      return keywords
        .map((keyword) => {
          return this.$parent.textPageList.find(
            (page) =>
              (page.slug && page.slug.toLowerCase().includes(keyword)) ||
              (page.title && page.title.toLowerCase().includes(keyword)),
          )
        })
        .filter((page) => page !== undefined)
    },
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN
  },
  methods: {
    handleSellItemsClick() {
      const settings = this.$parent.settings || {}
      const payoutMethods = settings.payout_methods

      const methods = Array.isArray(payoutMethods)
        ? payoutMethods
        : payoutMethods && typeof payoutMethods === 'object'
          ? Object.values(payoutMethods)
          : []

      const canSellItems =
        settings.payout_enabled === true &&
        methods.some((method) => method === 'card' || method === 'sepa')

      if (canSellItems) {
        this.$parent.openSellItemsModal()
      } else {
        this.$parent.openComingSoonModal()
      }
    },

    getSocialIcon(link) {
      if (!link) return ''
      const linkLower = link.toLowerCase()

      if (linkLower.includes('facebook') || linkLower.includes('fb')) {
        return this.acebookIcon
      }
      if (linkLower.includes('instagram')) {
        return this.instagramIcon
      }
      if (linkLower.includes('steam')) {
        return this.steamIcon
      }
      return this.acebookIcon
    },
    isFacebookLink(link) {
      return (
        link &&
        (link.toLowerCase().includes('facebook') ||
          link.toLowerCase().includes('fb'))
      )
    },
    formatStatus(status) {
      const map = {
        CounterOffer: 'Counter Offer',
        UserDeclined: 'Declined',
      }
      return map[status] || status
    },
  },
}
</script>
